<template>
  <div class="my_add_img">
    <!--一页模式，后面轮播模式继续封装-->
    <template>
      <ul class="one_page">
        <li class="add_btn el-icon-plus" @click="add_img"></li>
        <li class="one" v-for="(item,i) in imgs" :key="i" :imgs-id="item.widgets_id" v-if="item.data.full_screen_banner_pattern === 'banner'" @click="select_img(item,i)">
          <img :src="item.data.full_screen_banner.src">
          <i class="edit"></i>
          <span class="selected"></span>
          <b class="del el-icon-close"></b>
        </li>
      </ul>
    </template>

  </div>

</template>

<script>
import i18n from '../../language/index'

  /*
  * add_img 向外抛出的自定义事件
  *
  *
  * */
    export default {
        name: "my_add_img",
      props: {
        imgs: {
          type: Array,
          default:[]
        },
      },
      data () {
        return {
          select_id:0
        }
      },
      methods:{
        add_img(){
          this.$emit('add_img')
        },
        select_img(e){
          const obj = {
            data:e,
            i
          };
          this.$emit('select_img',obj);
          this.select_id = e;

        }
      },
      mounted(){
        console.log(this.imgs);
      }
    }
</script>

<style scoped lang="scss">


</style>



// WEBPACK FOOTER //
// src/components/my_add_img/index.vue